import React from "react";
import NavLink2 from "../compnents/NavLink2";
import Search from "../images/Group333.png";
import Footer5 from "../compnents/Footer5";
import Footer4 from "../compnents/Footer4";

import MMF2023 from "../data/TrustBanc Money Market Fund 2023 Abridged FS.pdf";
import MMF2024 from "../data/TrustBanc Money Market Fund 2024 Abridged FS.pdf";
import MMF2025 from "../data/TrustBanc Money Market Fund 2025 Abridged FS.pdf";

const financialStatements = [
  { label: "TrustBanc Money Market Fund 2023 Abridged Financial Statement", size: "227 KB", href: MMF2023 },
  { label: "TrustBanc Money Market Fund 2024 Abridged Financial Statement", size: "271 KB", href: MMF2024 },
  { label: "TrustBanc Money Market Fund 2025 Abridged Financial Statement", size: "256 KB", href: MMF2025 },
];

function FileIcon() {
  return (
    <div
      style={{
        width: "56px",
        height: "56px",
        backgroundColor: "#f2f2f2",
        borderRadius: "8px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
      }}
    >
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
        <path
          d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
          stroke="#044188"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <polyline
          points="14 2 14 8 20 8"
          stroke="#044188"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <line x1="8" y1="13" x2="16" y2="13" stroke="#044188" strokeWidth="1.8" strokeLinecap="round" />
        <line x1="8" y1="17" x2="14" y2="17" stroke="#044188" strokeWidth="1.8" strokeLinecap="round" />
      </svg>
    </div>
  );
}

function StatementCard({ label, size, href }) {
  return (
    <div
      style={{
        backgroundColor: "#FFFFFF",
        borderRadius: "12px",
        padding: "24px",
        boxShadow: "0px 2px 12px rgba(0, 0, 0, 0.07)",
        display: "flex",
        flexDirection: "column",
        gap: "16px",
      }}
    >
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
        <FileIcon />
        <div style={{ textAlign: "right" }}>
          <p style={{ margin: 0, fontSize: "11px", color: "#999", fontFamily: "Poppins", letterSpacing: "0.05em" }}>
            SIZE
          </p>
          <p style={{ margin: 0, fontSize: "15px", fontWeight: "700", fontFamily: "Poppins", color: "#222" }}>
            {size}
          </p>
        </div>
      </div>

      <h4 style={{ margin: 0, fontFamily: "Poppins", fontWeight: "700", fontSize: "17px", color: "#111" }}>
        {label}
      </h4>

      <div>
        <span
          style={{
            display: "inline-block",
            backgroundColor: "#f0f0f0",
            borderRadius: "20px",
            padding: "5px 16px",
            fontSize: "12px",
            fontFamily: "Poppins",
            fontWeight: "600",
            color: "#555",
            letterSpacing: "0.05em",
          }}
        >
          PDF REPORT
        </span>
      </div>

      <hr style={{ margin: "0", borderColor: "#eee" }} />

      <div style={{ textAlign: "right" }}>
        <a
          href={href}
          target="_blank"
          rel="noreferrer"
          style={{
            fontFamily: "Poppins",
            fontSize: "14px",
            fontWeight: "600",
            color: "#044188",
            textDecoration: "none",
          }}
        >
          View Details &rarr;
        </a>
      </div>
    </div>
  );
}

function MutualFundAbridgedFSPage() {
  return (
    <div style={{ backgroundColor: "#E5F0F5", width: "100%" }}>
      <div
        style={{
          backgroundImage: `url(${Search})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          height: "400px",
          boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.1)",
        }}
      >
        <NavLink2 />
        <div
          style={{
            textAlign: "center",
            position: "relative",
            top: "100px",
          }}
        >
          <h3
            style={{
              fontFamily: "Poppins",
              fontWeight: "700",
              fontSize: "50px",
              lineHeight: "75px",
              color: "#FFFFFF",
            }}
          >
            Mutual Fund Abridged Financial Statement
          </h3>
          <p
            style={{
              fontFamily: "Poppins",
              fontWeight: "400",
              fontSize: "16px",
              lineHeight: "28px",
              color: "#FFFFFF",
              maxWidth: "600px",
              margin: "0 auto",
              opacity: "0.9",
            }}
          >
            Access audited abridged financial statements for our mutual funds—providing full transparency into fund performance and governance.
          </p>
        </div>
      </div>

      <div
        style={{
          maxWidth: "1100px",
          margin: "60px auto",
          padding: "0 24px 80px",
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
          gap: "28px",
        }}
      >
        {financialStatements.map((statement, index) => (
          <StatementCard key={index} {...statement} />
        ))}
      </div>

      {/* App Download Section */}
      <div
        style={{
          background: "linear-gradient(269.87deg, #043e7f 39.64%, #075cc7 81.18%)",
          padding: "60px 24px",
          textAlign: "center",
        }}
      >
        <h3
          style={{
            fontFamily: "Poppins",
            fontWeight: "700",
            fontSize: "28px",
            color: "#FFFFFF",
            marginBottom: "12px",
          }}
        >
          Manage Your Investments On the Go
        </h3>
        <p
          style={{
            fontFamily: "Poppins",
            fontWeight: "400",
            fontSize: "15px",
            color: "#FFFFFF",
            opacity: "0.85",
            maxWidth: "520px",
            margin: "0 auto 32px",
            lineHeight: "26px",
          }}
        >
          Download the TrustBanc AM app to track your portfolio, access fund reports,
          and invest anytime, anywhere.
        </p>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "20px",
            flexWrap: "wrap",
          }}
        >
          {/* Google Play */}
          <a
            href="https://play.google.com/store/apps/details?id=com.prime.trustbancgroup"
            target="_blank"
            rel="noreferrer"
            style={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              backgroundColor: "#000000",
              color: "#FFFFFF",
              padding: "12px 24px",
              borderRadius: "10px",
              textDecoration: "none",
              minWidth: "180px",
            }}
          >
            <svg width="28" height="28" viewBox="0 0 24 24" fill="white">
              <path d="M3.18 23.76c.32.18.68.24 1.05.17l11.6-11.6-2.83-2.83L3.18 23.76zM20.54 10.27l-2.33-1.35-3.17 3.17 3.17 3.17 2.36-1.37c.67-.39.67-1.23-.03-1.62zM1.5.7C1.19 1.02 1 1.5 1 2.09v19.82c0 .59.19 1.07.5 1.39l.07.07L13.24 11.7v-.29L1.57.63 1.5.7zM13.95 7.55l-10.7-6.2 9.76 9.76 2.83-2.83-.74-.44-.15-.29z" />
            </svg>
            <div style={{ textAlign: "left" }}>
              <div style={{ fontSize: "10px", fontFamily: "Poppins", opacity: 0.8 }}>GET IT ON</div>
              <div style={{ fontSize: "16px", fontFamily: "Poppins", fontWeight: "700" }}>Google Play</div>
            </div>
          </a>

          {/* App Store */}
          <a
            href="https://apps.apple.com/ng/app/trustbanc-prime-pro/id6739510806"
            target="_blank"
            rel="noreferrer"
            style={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              backgroundColor: "#000000",
              color: "#FFFFFF",
              padding: "12px 24px",
              borderRadius: "10px",
              textDecoration: "none",
              minWidth: "180px",
            }}
          >
            <svg width="28" height="28" viewBox="0 0 24 24" fill="white">
              <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
            </svg>
            <div style={{ textAlign: "left" }}>
              <div style={{ fontSize: "10px", fontFamily: "Poppins", opacity: 0.8 }}>DOWNLOAD ON THE</div>
              <div style={{ fontSize: "16px", fontFamily: "Poppins", fontWeight: "700" }}>App Store</div>
            </div>
          </a>
        </div>
      </div>

      <Footer5 />
      <div className="footer-4">
        <Footer4 />
      </div>
    </div>
  );
}

export default MutualFundAbridgedFSPage;
